/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Cookies.jsx
 * description   : {{insert here}}
 * creation date : 18/03/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    View,
    Text,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';

import {
    ViewPortContainer,
} from '@/components/snippets/CustomDiv';

import {
    Separator,
    ContentContainer,
} from '@/components/snippets/ContentDiv';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Cookies() {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <ContentContainer
                title='Cookie policy' // TODO: Translate message
            >
                <ViewPortContainer>
                    <View
                        width={ctx.theme.tokens.space.relative.full}
                        padding={
                            ctx.api.utils.adaptiveOption(
                                ctx.theme.tokens.space.large,
                                ctx.theme.tokens.space.large,
                                ctx.theme.tokens.space.medium
                            )
                        }
                    >
                        <Text
                            className='main-home-text'
                        >
                            {/* TODO: Translate message */}
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                            arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                            Fusce cursus, sapien mollis bibendum mattis, magna orci sollicitudin metus,
                            eu malesuada erat diam non erat. Mauris enim justo, auctor in est vitae, tempus finibus risus.
                            Cras a augue consectetur, ultrices elit vel, ultricies nisi. Curabitur leo lacus,
                            vehicula vel commodo id, pulvinar vel lacus. Fusce venenatis justo mauris,
                            sit amet fringilla leo dignissim mattis. Maecenas lacinia enim non purus porta,
                            et ultrices dui consectetur. Vivamus pellentesque magna mauris, ac vulputate felis efficitur eget.
                            Suspendisse nunc quam, molestie id odio non, vehicula vestibulum est. Phasellus nec lacinia velit,
                            et lacinia turpis. Pellentesque rhoncus ipsum consectetur rhoncus rhoncus.
                            Phasellus elementum ultrices nibh, a vestibulum est euismod ac. Sed risus mauris,
                            condimentum quis diam id, fringilla hendrerit leo. Duis quis varius nisi, quis porttitor purus.
                            Donec sed pretium sapien. Proin sagittis risus in lobortis vulputate.
                        </Text>

                        <Separator
                            height={
                                ctx.api.utils.adaptiveOption(
                                    ctx.theme.tokens.space.medium,
                                    ctx.theme.tokens.space.small,
                                    ctx.theme.tokens.space.xs
                                )
                            }
                        />

                        <Text
                            className='main-home-text'
                        >
                            {/* TODO: Translate message */}
                            Cras egestas libero mi, eget posuere massa tristique sed. Morbi sed magna maximus,
                            mollis justo id, laoreet leo. Curabitur accumsan odio id laoreet tincidunt.
                            Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                            Interdum et malesuada fames ac ante ipsum primis in faucibus. Aliquam erat volutpat.
                            Phasellus nulla lorem, varius et mauris ut, fermentum ultrices eros. Suspendisse dictum odio eros,
                            non pellentesque justo maximus a. Fusce vel dui malesuada, convallis libero ornare, efficitur felis.
                            Suspendisse potenti. Nam ultricies augue nec porta varius. Sed eleifend orci eu felis pharetra tristique.
                            Duis a tellus sit amet nisi commodo auctor lobortis at tortor. Duis sit amet egestas odio,
                            id tincidunt tellus. Ut id iaculis orci. Vivamus lobortis commodo scelerisque.
                        </Text>

                        <Separator
                            height={
                                ctx.api.utils.adaptiveOption(
                                    ctx.theme.tokens.space.medium,
                                    ctx.theme.tokens.space.small,
                                    ctx.theme.tokens.space.xs
                                )
                            }
                        />

                        <Text
                            className='main-home-text'
                        >
                            {/* TODO: Translate message */}
                            Cras a commodo ante. Fusce auctor magna et massa gravida, eget tristique ante finibus.
                            In non quam faucibus, aliquet ligula eget, maximus nisi. Duis finibus, risus vitae ultricies pharetra,
                            est dui finibus massa, non scelerisque nisl enim id risus. Fusce at odio ipsum. Cras mattis risus ante,
                            vitae rhoncus dolor cursus ut. Donec vel sapien ut erat rutrum interdum ut sit amet sem.
                            Proin tristique leo eu massa placerat sodales. Phasellus aliquam pharetra porttitor.
                            Aenean posuere mattis dui, finibus efficitur elit porttitor quis.
                        </Text>

                        <Separator
                            height={
                                ctx.api.utils.adaptiveOption(
                                    ctx.theme.tokens.space.medium,
                                    ctx.theme.tokens.space.small,
                                    ctx.theme.tokens.space.xs
                                )
                            }
                        />

                        <Text
                            className='main-home-text'
                        >
                            {/* TODO: Translate message */}
                            Suspendisse massa sapien, accumsan non porta vel, gravida sit amet nisi.
                            Vestibulum vitae posuere ligula. Vivamus nunc quam, pharetra quis varius at, iaculis vitae lectus.
                            Pellentesque sed mi sit amet sapien venenatis elementum. Praesent sodales ante quis rhoncus elementum.
                            Sed est nisl, bibendum eget magna eget, vulputate iaculis lorem. Morbi cursus pretium est blandit suscipit.
                            Morbi sed lacinia nisl. Suspendisse lobortis nec metus non ultrices. Pellentesque nunc ante,
                            lobortis ac nibh nec, maximus egestas odio. Donec molestie imperdiet luctus. Proin nisi ex,
                            tincidunt maximus nulla nec, hendrerit facilisis nibh. Etiam a nisl vitae turpis porta bibendum posuere ut arcu.
                            Vestibulum et neque sed erat sodales porta vitae id sapien.
                        </Text>

                        <Separator
                            height={
                                ctx.api.utils.adaptiveOption(
                                    ctx.theme.tokens.space.medium,
                                    ctx.theme.tokens.space.small,
                                    ctx.theme.tokens.space.xs
                                )
                            }
                        />

                        <Text
                            className='main-home-text'
                        >
                            {/* TODO: Translate message */}
                            Aenean lobortis ante scelerisque risus fermentum, et luctus dui mollis.
                            Sed semper metus a iaculis dapibus. Aliquam eu lobortis turpis.
                            Integer nec purus a dui ullamcorper tempor eget vitae leo.
                            Pellentesque nec purus in ex lacinia dictum et non tortor. Duis enim lorem, sodales sed purus consequat,
                            sodales varius massa. Vestibulum eget elit turpis. Orci varius natoque penatibus et magnis dis parturient montes,
                            nascetur ridiculus mus. Praesent sodales et justo ac imperdiet.
                            Etiam eu dolor a nunc malesuada elementum et eu dui. Sed at dui vehicula, vulputate enim ut, finibus dolor.
                            Sed tincidunt ipsum commodo neque laoreet commodo. Etiam sapien odio, congue id quam a, bibendum faucibus enim.
                        </Text>
                    </View>
                </ViewPortContainer>
            </ContentContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Cookies;



// End of file
